import { useMutation } from '@apollo/client'

import { CreatePricedCataloguedProductDocument } from '@/graphql/purchase-plus/generated/createPricedCataloguedProduct.generated'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'

export default function useCreatePricedCatalogedProduct() {
  const mutation = useMutation(CreatePricedCataloguedProductDocument, {
    context: {
      uri: PURCHASE_PLUS_GRAPHQL_API,
    },
  })

  return mutation
}
